var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTsm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M325.48,433H79a49,49,0,0,1,0-98h96a79,79,0,0,0,0-158H122.52a76.75,76.75,0,0,1,0,30H175a49,49,0,0,1,0,98H79a79,79,0,0,0,0,158H325.48A76.46,76.46,0,0,1,324,448,77.23,77.23,0,0,1,325.48,433Z",
    transform: "translate(0 -17)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M401,401a47,47,0,1,0,47,47A47,47,0,0,0,401,401Z",
    transform: "translate(0 -17)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143,17H47A15,15,0,0,0,32,32V147.47a47,47,0,1,0,30,0V111h81a15,15,0,0,0,15-15V32A15,15,0,0,0,143,17Z",
    transform: "translate(0 -17)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M401,49a111,111,0,0,0-71.37,196l58,113.8a15,15,0,0,0,26.72,0l58-113.79A111,111,0,0,0,401,49Zm0,158a47,47,0,1,1,47-47A47,47,0,0,1,401,207Z",
    transform: "translate(0 -17)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTsm);
export default __webpack_public_path__ + "static/media/iconTSM.7022883c0cb0eae102b95236300b34f3.svg";
export { ForwardRef as ReactComponent };